// export const BASE_URL = "http://13.203.236.28:8009";
// export const BASE_URL = "http://3.6.113.160:8008";
export const BASE_URL = "https://api.gmkmc.com/";
